/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames'
import React, { ReactElement } from 'react'
import style from './SocialButton.module.css'

interface ISocialButtonProps {
  className: string
  children: ReactElement
  onClick: React.MouseEventHandler
}

export const SocialButton: React.FC<ISocialButtonProps> = ({ className, children, ...props }) => {
  const finalClassName = classNames(style.button, className)

  return (
    <button type="button" className={finalClassName} {...(props as React.HTMLAttributes<HTMLButtonElement>)}>
      {children}
    </button>
  )
}

SocialButton.displayName = 'SocialButton'
